export enum EventsNames {
  InvolvingProcess = 'ParticipantOffersInvolvingProcess',
  PowerOfAttorney = 'PowerOfAttorneyChanged',
  EtpFeeNotPaid = 'EtpFeeNotPaid',
  CloudLogisticEvent = 'CloudLogisticEvent',
  CustomUserEvent = 'CustomUserEvent',
  LkLogoutRequired = 'LkLogoutRequired',
  UserAlertsChanges = 'UserAlertsChanges',
  CustomerAllContragentsReportReady = 'CustomerAllContragentsReportReady',
  PageRefreshRequired = 'PageRefreshRequired',
  LkAlertAppeared = 'LkAlertAppeared'
}
